const KEY = "s_item_id";

import { findIndex } from "lodash";
const store = (s) => localStorage.setItem(KEY, JSON.stringify(s));
const clear = () => localStorage.removeItem(KEY);

const get = () => {
  const data = localStorage.getItem(KEY);
  if (data) {
    clickList = JSON.parse(data);
    return clickList;
  }
  return null;
};

let clickList;

const getClicklist = () => {
    if(clickList) return clickList;
    return get();
}

const hasClick = itemId => findIndex(clickList, (i) => parseInt(i) === itemId) > -1

const clickProduct = (itemId) => {
  const list = get();
  if (findIndex(list, (i) => parseInt(i) === itemId) > -1) return;
  if (!list) {
    store(new Array(`${itemId}`));
  } else store([...list, `${itemId}`]);
};

export { clickProduct, getClicklist, hasClick, clear};
